import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import "./style.scss";
import MyProfileContent from "./MyProfileContent";
import DoctorContext from "../ClinicWrapper/DoctorContext";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { USER_ROLE, USER_TYPE } from "../../../Util/constants";
import DashboardAccounts from "../../common/DashboardAccounts/DashboardAccounts";

export default function TabComponent(props) {
  const {
    showRatingPopup,
    callLastConsultationFeedback,
    setCallLastConsultationFeedback,
    scrollRef,
  } = props;

  const [activeTab, setActiveTab] = useState(1);
  const [key, setKey] = useState(0);

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  }));

  const classes = useStyles();
  const [doctor_selected, setDoctorSelected] = useState([]);
  const doctor_context = useContext(DoctorContext);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  useEffect(() => {
    if (doctor_context.selectedDoctor.length !== 0) {
      let arr = [];
      doctor_context?.selectedDoctor &&
        doctor_context.selectedDoctor.map(
          (data) => data?.selected === true && arr.push(data.doctor_id)
        );
      setDoctorSelected(arr);
      setKey((prev) => prev + 1);
    } else {
      setDoctorSelected([]);
    }
  }, [doctor_context.selectedDoctor]);

  let is_staff = localStorage.getItem("user_type");

  // Actions ===>

  const handleActiveTab = (val) => {
    setActiveTab(val);
  };

  // <==

  // Display UI ===>

  const displayTabs = () => {
    return (
      <div className="tab-component-tabs-cont">
        <div
          className={
            "tab-component-tabs " +
            (activeTab === 1 ? "tab-component-tab-selected" : "")
          }
          onClick={() => handleActiveTab(1)}
        >
          My Profile
        </div>
        <div
          className={
            "tab-component-tabs " +
            (activeTab === 2 ? "tab-component-tab-selected" : "")
          }
          onClick={() => handleActiveTab(2)}
        >
          Accounts ({doctor_selected.length})
        </div>
      </div>
    );
  };

  const displayTabContent = () => {
    return (
      <div className="tab-component-tab-content">
        {activeTab === 1 && (
          <MyProfileContent
            showRatingPopup={showRatingPopup}
            callLastConsultationFeedback={callLastConsultationFeedback}
            setCallLastConsultationFeedback={setCallLastConsultationFeedback}
            callNextAppointmentWidget={props?.callNextAppointmentWidget}
          />
        )}
        {activeTab === 2 && (
          <DashboardAccounts
            key={key}
            scrollRef={scrollRef}
            doctor_selected={doctor_selected}
            callNextAppointmentWidget={props?.callNextAppointmentWidget}
          />
        )}
      </div>
    );
  };

  // <===

  return (
    <div>
      {localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE) ===
        USER_ROLE.RESOURCE_ADMIN || is_staff === USER_TYPE.STAFF ? (
        <DashboardAccounts
          key={key}
          scrollRef={scrollRef}
          doctor_selected={doctor_selected}
          callNextAppointmentWidget={props?.callNextAppointmentWidget}
        />
      ) : (
        <div className={classes.root}>
          <div className={classes.main}>
            {displayTabs()}
            {displayTabContent()}
          </div>
        </div>
      )}
    </div>
  );
}
